import { render, staticRenderFns } from "./ReviewExLearning.vue?vue&type=template&id=969059d2&"
import script from "./ReviewExLearning.vue?vue&type=script&lang=js&"
export * from "./ReviewExLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports